import { useEffect, useContext } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { getUserID } from '../../service';
import { RegionContext } from '../../contexts/regionContext';

export default function RegionApp() {
  const navigate = useNavigate();
  const location = useLocation();
  const [regionData, setRegionData] = useContext(RegionContext);

  const getUserData = async () => {
    try {
      const resData = await getUserID();
      console.log('resData', resData);
      let formData = {
        id: resData.data._id
      };
      console.log('formData', formData);
      setRegionData({ formData });
    } catch (e) {
      localStorage.removeItem('regionToken');
      navigate('/region/login');
    }
  };

  useEffect(() => {
    // if login or magic links, skip fetching
    if (location.pathname === '/region/login' || location.pathname === '/region/magic') return;
    if (regionData?.formData?.id) return;
    getUserData();
  }, [location.pathname]);

  useEffect(() => {
    console.log('regionData====>', regionData);
  }, [regionData]);

  return <Outlet />;
}
